import React from 'react';

export default class Links extends React.Component {

    constructor() {
        super();
    }

    componentDidMount() {
        // const links = document.querySelectorAll('.links .link');

        // links.forEach(link => {
        //     link.addEventListener('click', () => {
        //         if (localStorage.getItem('cookiesAccepted') === 'true') {
        //             ReactGA.event({
        //                 category: 'Link',
        //                 action: link.id + '-click'
        //             });
        //         }
        //     });
        // })
    }

    render() {
        return (
            <>
                <div className='links'>
                    <a className='link' target="_blank" id='privacy-policy' href="https://darabase.com/privacy-policy/">Privacy Policy</a>
                    <a className='link' target="_blank" id='cookie-notice' href="https://darabase.com/cookies/">Cookie Notice</a>
                </div>
            </>
        )
    }
}
